// extracted by mini-css-extract-plugin
module.exports = {"icon":"TooltipIcon__icon__dVPpC","tooltip":"TooltipIcon__tooltip__ohxeO","arrow":"TooltipIcon__arrow__oSOpG"};